// HEAL-52 (часть a) — объяснение статуса на карточке маркера.
//
// Претензия тикета: «непонятно, по какому принципу считается статус». По ТТГ
// пользователь видел значение 2,19 внутри показанной ему нормы 0,4–4,0 и при этом
// оранжевый статус — и прочитал это как ошибку приложения. Механика была верной
// (оранжевый = в норме, но вне оптимума), но объяснение жило в другом блоке экрана,
// а противоречие било в глаза сразу.
//
// Здесь живёт только текст. Расчёт статуса не трогаем — цвет и тир по-прежнему
// приходят с бэка, иначе мы бы завели ВТОРОЙ источник правды о статусе, ровно тот
// механизм, из-за которого шапка и график когда-то разошлись в цвете (HEAL-35).

export type StatusTier = 'norm' | 'attention' | 'bad' | 'no-range';

export type ExplainInput = {
  tier: StatusTier;
  /** null у качественных показателей — там результат это слово, а не число. */
  value: number | null;
  normalMin: number | null;
  normalMax: number | null;
  /** null, когда чисел оптимума нет (нет для пола/возраста, качественный, спорный код). */
  optimumMin: number | null;
  optimumMax: number | null;
};

/**
 * Одна фраза под диапазонами: почему статус именно такой.
 * `null` — фразы не нужно, диапазонов достаточно.
 *
 * Сторону («выше» / «ниже») говорим СЛОВОМ, без стрелок: в приложении стрелка
 * означает динамику (v0.99.195), и ↑ рядом со статусом читалось бы как «растёт».
 */
export function explainStatus({
  tier,
  value,
  normalMin,
  normalMax,
  optimumMin,
  optimumMax,
}: ExplainInput): string | null {
  const hasOptimum = optimumMin !== null && optimumMax !== null;

  if (tier === 'no-range') {
    return 'Норма не определена для вашего пола или возраста.';
  }

  if (tier === 'bad') {
    if (value === null || normalMin === null || normalMax === null) {
      return 'Есть смысл обсудить результат с врачом.';
    }
    const side = value > normalMax ? 'выше' : 'ниже';
    return `Результат ${side} нормы. Есть смысл обсудить его с врачом.`;
  }

  if (tier === 'attention') {
    // Чисел оптимума нет → остаётся прежняя мягкая формулировка. Врать про
    // несуществующий диапазон нельзя, а промолчать здесь тем более: оранжевый
    // без объяснения — исходная жалоба.
    if (value === null || !hasOptimum) {
      return 'Результат в пределах нормы, но не оптимален.';
    }
    const side = value > optimumMax ? 'выше' : 'ниже';
    return `Результат в пределах нормы, но ${side} оптимума HealthLab. Это не отклонение.`;
  }

  return hasOptimum ? 'Ваш результат внутри обоих диапазонов.' : null;
}
